import { RefObject, useEffect, useMemo, useRef } from "react"

interface UseDetectStickyParams {
  ref?: RefObject<HTMLDivElement | null>
  observerSettings?: IntersectionObserverInit
  onIntersectionTriggered?: (isSticky: boolean) => void
}

export const useDetectSticky = (params?: UseDetectStickyParams): RefObject<HTMLDivElement | null> => {
  const newRef = useRef<HTMLDivElement>(null)
  const { ref: initialRef, observerSettings: initialObserverSettings, onIntersectionTriggered } = { ...params }
  const ref = initialRef ?? newRef
  const observerSettings = useMemo(() => initialObserverSettings ?? { threshold: [1] }, [initialObserverSettings])

  useEffect(() => {
    if (!ref.current) return

    const cachedRef = ref.current,
      observer = new IntersectionObserver(([entry]) => {
        if (onIntersectionTriggered) {
          const isSticky = entry.intersectionRatio < 1
          onIntersectionTriggered(isSticky)
        }
      }, observerSettings)

    observer.observe(cachedRef)

    return () => {
      observer.unobserve(cachedRef)
    }
  }, [observerSettings, onIntersectionTriggered, ref])

  return ref
}
